import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import {withRouter} from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import {getSchool} from '../../actions';
import SchoolDetailsPlaceholder from './SchoolDetailsPlaceholder';
import SchoolDetails from './SchoolDetails'
import isEmpty from '../../../../app/utils/isEmpty';
import {withLocalize} from 'react-localize-redux';

class SchoolDetailsContainer extends Component {
    fetchContent() {
        let slug = this.props.match.params.slug;

        this.props.getSchool(slug);
    }

    componentDidMount() {
        this.fetchContent();
    }

    componentDidUpdate(prevProps, prevState) {
        const {school, loading, errors} = this.props;

        if (prevProps.languages !== this.props.languages) {
            this.fetchContent();
        }

        if (prevProps.errors !== errors && !loading) {
            if (errors.status === 303) {
                let uri = this.props.translate('routes.schools_details').replace(':slug', errors.data.redirect);

                this.props.history.push(uri);
            }
        }

        if (!loading && isEmpty(school)) {
            if (errors.status === 422) {
                setTimeout(() => {
                    this.props.history.push('/404');
                }, 2000);
            }
        }
    }

    render() {
        const {school, loading} = this.props;

        if (isEmpty(school) || loading) {
            return (
                <Fragment>
                    <Helmet
                        bodyAttributes={{
                            class: 'school'
                        }}
                    >
                        <title>{process.env.REACT_APP_SITE_TITLE}</title>
                    </Helmet>
                    <div className="container">
                        <SchoolDetailsPlaceholder/>
                    </div>
                </Fragment>
            );
        }

        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'school'
                    }}
                >
                    <title>{(school.seo_title !== '' ? school.seo_title : school.title) + ' ' + process.env.REACT_APP_HEAD_TITLE_SEPARATOR + ' ' + process.env.REACT_APP_SITE_TITLE}</title>
                    {school.seo_meta_description !== '' &&
                        <meta name="description" content={school.seo_meta_description} />
                    }
                    {school.seo_facebook_og_title !== '' &&
                        <meta property="og:title" content={school.seo_facebook_og_title} />
                    }
                    {school.seo_facebook_og_description !== '' &&
                        <meta property="og:description" content={school.seo_facebook_og_description} />
                    }
                    {school.seo_facebook_og_image !== '' &&
                        <meta property="og:image" content={school.seo_facebook_og_image} />
                    }
                </Helmet>
                <div className="container">
                    <SchoolDetails school={school}/>
                </div>
            </Fragment>
        );
    }
}

SchoolDetailsContainer.propTypes = {
    getSchool: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    school: state.schools.school,
    loading: state.schools.schoolLoading,
    errors: state.schools.schoolErrors,
});

export default withRouter(connect(mapStateToProps, {getSchool})(withLocalize(SchoolDetailsContainer)));



// WEBPACK FOOTER //
// ./src/features/Schools/components/Details/SchoolDetailsContainer.js